import styled from 'styled-components';

export const StyledInput = styled.input(
    ({ theme }) => `
    border-radius: 0.8rem;
    color: ${theme.sections.header.a};
    background-color: ${theme.sections.header.d};
    border: 0.06rem solid ${theme.sections.header.c};
    outline: none;
    line-height: 90%;
    padding: 0.15rem 1.875rem 0.125rem 0.875rem;
    transition: all 0.3s;
    width: 100%;
    font-size: 1rem;
`,
);

export const InputWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const SearchIcon = styled.i(
    ({ theme }) => `
    color: ${theme.sections.header.a};
    font-weight: bold;


    &.fa {
        font-weight: bold;
        font-size: 1rem;
    }

    @media (hover: hover) {
        &:hover {
            color: ${theme.sections.header.featureMouseover};
        }
    }
`,
);

export const ClearIcon = styled.i(
    ({ theme }) => `
    color: ${theme.sections.header.a};
    cursor: pointer;
    position: absolute;
    right: 0.4rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.2rem;

    &.fa {
        font-size: 0.7rem;
        font-weight: bold;
    }
`,
);

export const StyledForm = styled.form<{ open: boolean }>(
    ({ open, theme }) => `
    display:flex;
    gap: .5rem;
    padding: 0 1rem;
    justify-content: end;
    align-items: center;
    width: 100%;

    ${InputWrapper}{
        margin-left: auto;
        margin-right: 0;
        transition: width ${open ? '.3s' : '0s'};
        width: ${open ? '100%' : '0px'};
        justify-self: end;
        overflow: hidden;
    }

    ${SearchIcon}{
        cursor: ${open ? 'default' : 'pointer'};
    }

    ${
        open &&
        `
        ${SearchIcon}{
            color: ${theme.sections.header.a};
        }
    `
    }

    ${ClearIcon}{
        display: ${open ? 'block' : 'none'};
    }
`,
);
